import { AfterViewInit, Component, OnDestroy, OnInit, QueryList, ViewChildren } from '@angular/core';

import { Subscription } from 'rxjs';
import { DynamicFormCommonConfig } from 'zr-dynamic-form/dynamic-form-common';

import { DynamicFormComponent } from '../../dynamic-form/dynamic-form/dynamic-form.component';
import { DynamicFormDataModel } from '../../dynamic-form/utils/dynamic-form-context.type';
import { ControlTypeName, ValueControlViewModel } from '../../types';
import { AbstractValueControlBase } from '../../types/abstract-value-control-base';
import { DynamicFormModel, mergeDiffContent, toDynamicFormModel } from '../../utils/dynamic-form-model';
import { camelCaseObject } from '../../utils/http-helper';

@Component({
  selector: 'df-child-form-control',
  templateUrl: './child-form-control.component.html',
  styleUrls: ['./child-form-control.component.scss']
})
export class ChildFormControlComponent extends AbstractValueControlBase<DfFormControlViewModel>
  implements OnInit, AfterViewInit, OnDestroy {
  type = ControlTypeName.childForm;

  /**
   * æ¯å¦æ¯å­è¡¨å
   */
  isChildForm = true;

  /**
   * æå¤å¯ä»¥æ·»å æ¡æ°
   *
   */
  maxAccount = 30;

  get valid(): boolean {
    if (this._loading) {
      return false;
    }

    return (
      this.childrenDynamicForm &&
      this.childrenDynamicForm.filter((s) => s.valid === false).length === 0 &&
      this.getValidState()
    );
  }

  childrenDynamicFormModels: ChildDynamicFormModel[] = [];
  childrenDynamicFormSubscriptions: Subscription[] = [];
  formContent: DynamicFormModel;
  @ViewChildren('dynamic') childrenDynamicForm: QueryList<DynamicFormComponent>;

  private _isFirstSetChildren: boolean;
  private _loading: boolean = true;

  constructor(private commonConfig: DynamicFormCommonConfig) {
    super();
  }

  ngOnInit() {
    this.model.addButtonText = this.model.addButtonText || 'æ·»å ';
    this.model.deleteButtonText = this.model.deleteButtonText || 'å é¤';
  }

  ngAfterViewInit() {
    this.propertyValueChanged$.subscribe((s) => {
      // çº§èäºæ ç­¾ï¼çå¬æ ç­¾çååå°±è¡
      if (s.name === 'formLabelCode') {
        this.loadFormContent();
      }
    });

    if (this.model.formCode) {
      this.loadFormContent();
    }

    this.childrenDynamicForm.changes.subscribe(() => {
      this.unSubscribeChildValueChanged();
      this.subscribeChildValueChanged();

      // å­è¡¨åå è½½å®æåè§¦åä¸æ¬¡ï¼ ç¬¬ä¸æ¬¡èµå¼çæ¶åï¼ä¸æ¹åå¼ï¼ä½æ¯å¦ææåé¨å¼æ¹åï¼è¿æ¯éè¦æ¹åç
      if (this._isFirstSetChildren) {
        this._isFirstSetChildren = false;
        return;
      }

      this.model.value = this.getModelValue();
      this.valueChange(null);
    });
  }

  ngOnDestroy(): void {
    this.unSubscribeChildValueChanged();
  }

  add(index: number) {
    if (!this.formContent || !this.allowAdd()) {
      return;
    }
    this.childrenDynamicFormModels.splice(index + 1, 0, {
      content: this.formContent,
      targetId: this.dataConfig.targetId,
      isAdd: true
    });
  }

  addAtLast() {
    if (!this.formContent || !this.allowAdd()) {
      return;
    }
    this.childrenDynamicFormModels.push({ content: this.formContent, targetId: this.dataConfig.targetId, isAdd: true });
  }

  remove(index: number) {
    if (!this.formContent) {
      return;
    }

    this.commonConfig.dialog.confirm(`ç¡®å®å é¤ï¼`).subscribe(
      () => {
        this.childrenDynamicFormModels.splice(index, 1);
      },
      () => {}
    );
  }

  setModelValue(values: DynamicFormDataModel[]) {
    if (!values) {
      this.model.value = [];
    } else {
      this.model.value = values;
    }

    if (this.formContent) {
      this.setChildrenDynamicFormModels();
    }
  }

  getModelValue(): DynamicFormDataModel[] {
    // é¢è§çæ¶åä¸éè¦ï¼è¿è¡æ¶æéè¦
    const values = this.childrenDynamicForm.map((s) => s.getCurrentDataModel(s.targetId));
    return values;
  }

  private allowAdd() {
    if (this.childrenDynamicFormModels.length >= 30) {
      this.commonConfig.log.warn('æå¤åªè½æ·»å 30æ¡æ°æ®');
      return false;
    }
    return true;
  }

  private setChildrenDynamicFormModels() {
    if (!this.model.value) {
      return;
    }
    this.childrenDynamicFormModels = (this.model.value as DynamicFormDataModel[]).map((s) => {
      return { content: this.formContent, value: s, targetId: this.dataConfig.targetId, isAdd: false };
    });
    this._isFirstSetChildren = true;
  }

  private loadFormContent() {
    this._loading = true;

    if (!this.model.formCode) {
      this.model.value = [];
      this._loading = false;
      return;
    }

    this.controlShared.getFormContent(this.model.formCode, this.model.formLabelCode).subscribe(
      (s) => {
        // ä¿®æ­£å¾ªç¯æ£æ¥éè¯¯ï¼å ä¸ºå¦æå½ä¸­ç¼å­ä¼ç«å³è¿åï¼ç«å³è®¾ç½®å­è¡¨åmodelä¼ä¿®æ¹å·²ç»æ£æ¥è¿çå¼
        Promise.resolve().then(() => {
          const formModel = toDynamicFormModel(JSON.parse(s.formContent));
          this.formContent = mergeDiffContent(formModel, camelCaseObject(JSON.parse(s.labelContent)));
          // å ä¸ºèµå¼ä¼åäºè¡¨åcontentå è½½å®æ¯ï¼æä»¥è¡¨åç»æè·åå®æ¯åä¼å è½½ä¸æ¬¡ï¼
          this.setChildrenDynamicFormModels();
          this._loading = false;
        });
      },
      () => {
        this.commonConfig.log.error('å­è¡¨åè·åå¤±è´¥');
      }
    );
  }

  private subscribeChildValueChanged() {
    this.childrenDynamicFormSubscriptions = [];
    // éè¦æ³¨æåæ¶è®¢é
    this.childrenDynamicForm.map((d) => {
      const sub = d.valueChanged$.subscribe(() => {
        this.model.value = this.getModelValue();
        this.valueChange(undefined);
      });
      this.childrenDynamicFormSubscriptions.push(sub);
    });
  }

  private unSubscribeChildValueChanged() {
    this.childrenDynamicFormSubscriptions.map((s) => s.unsubscribe());
  }
}

interface DfFormControlViewModel extends ValueControlViewModel {
  formCode: string;
  formLabelCode: string;
  addButtonText?: string;
  deleteButtonText?: string;
}

// å­è¡¨åæ¨¡å
interface ChildDynamicFormModel {
  content: any;
  targetId?: string;
  value?: any;
  isAdd?: boolean;
}
